import { createSlice } from '@reduxjs/toolkit';
import {
    ultimoEntorno,
} from '../actions/ultimoEntorno';


export const UltimoEntornoReducerNodo = createSlice({
    name: 'ultimoEntorno',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(ultimoEntorno.pending, (state) => { state.loading = true })
            .addCase(ultimoEntorno.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(ultimoEntorno.rejected, (state) => { state.loading = false })
    }
})

export default UltimoEntornoReducerNodo.reducer;
